import React, { useState } from "react";

import useInView from "hooks/useInView";
import { useWaitlist } from "contexts/waitlist";
import "./waitlist.scss";

const Waitlist = () => {
  const [email, setEmail] = useState("");
  const [ref, inView] = useInView();
  const {
    state: { status },
    submit,
  } = useWaitlist();

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(email);
  };

  return (
    <section id="waitlist" className="waitlist">
      <div ref={ref} className={`waitlist-inner ${inView ? "visible" : ""}`}>
        <div className="waitlist-card">
          <h2 className="waitlist-heading">
            See what's actually worth buying in your market.
          </h2>
          <p className="waitlist-sub">
            NextFlip is in early access. Drop your email and we'll let you know
            when it's live.
          </p>
          {status === "success" ? (
            <div className="waitlist-confirmed">
              <span>You're on the list. We'll be in touch.</span>
            </div>
          ) : (
            <form className="waitlist-form" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                aria-label="Email address"
              />
              <button type="submit" disabled={status === "loading"}>
                {status === "loading" ? "Submitting\u2026" : "Get Early Access"}
              </button>
            </form>
          )}
          {status === "error" && (
            <span className="waitlist-error">
              Something went wrong. Please try again.
            </span>
          )}
          <span className="waitlist-note">
            Free during beta. No credit card required.
          </span>
        </div>
      </div>
    </section>
  );
};

export default Waitlist;
